import {ChangeDetectionStrategy, Component, ElementRef, EventEmitter, input, OnDestroy, Output, ViewChild} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {Subscription} from 'rxjs';
import {MatFormFieldAppearance, MatFormFieldModule} from '@angular/material/form-field';
import {ThemePalette} from '@angular/material/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {ReactiveFormsModule} from '@angular/forms';
import {MatDatetimeComponent} from '../mat-datetime/mat-datetime.component';

@Component({
    selector: 'xui-mat-date-time-picker',
    templateUrl: './app-mat-date-time-picker.component.html',
    styleUrls: ['./app-mat-date-time-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
      MatFormFieldModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule,
      ReactiveFormsModule, MatDatetimeComponent
    ]
})
export class AppMatDateTimePickerComponent implements OnDestroy {

  readonly appearance = input<MatFormFieldAppearance>('fill');
  readonly color = input<ThemePalette>('primary');
  readonly parentForm = input<UntypedFormGroup | undefined>();
  readonly name = input('');
  readonly label = input('Date & Time');
  readonly readonly = input(false);
  readonly validate = input(true);
  readonly dateFormat = input('Y-m-d H:i');
  readonly defaultHour = input(12);
  readonly defaultMinute = input(0);
  readonly defaultIncrement = input(15);
  readonly processing = input(false);
  @Output() action: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('input') input: ElementRef;
  private valueChanges: Subscription;

  ngOnDestroy(): void {
    this.valueChanges?.unsubscribe();
  }

  get hasActionObservers(): boolean {
    return this.action.observers.length > 0;
  }

  performAction() {
    this.action.emit(true);
  }

}
